<div class="innerPagesBlock">
  <app-side-menu></app-side-menu>
  <div class="admin-panel" *ngIf="!loading; else loader">
    <!-- <app-banner-footer-pages [title]="title1"></app-banner-footer-pages> -->
    <!-- <app-banner-profile [image]="img1" [title]="title1" [customClasses]="class1"></app-banner-profile> -->
    <div class="adminppgContent">
      <form class="businessValidationformBox mb-3 filterform" [formGroup]="filterForm">
        <div class="innerpageContent">
          <div class="row">
            <div class="col-lg-3">
              <div class="inputGroup">
                <mat-form-field class="w-100 mat-input-group" appearance="outline">
                  <mat-label class="matLabel">Category </mat-label>
                  <mat-select multiple formControlName="categoryIn">
                    <mat-option [value]="" *ngIf="categoryList.loading"><i>Loading ...</i></mat-option>
                    <mat-option *ngFor="let category of categoryList.response" [value]="category.id">
                      {{ category.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="inputGroup">
                <mat-form-field class="w-100 mat-input-group" appearance="outline">
                  <mat-label class="matLabel">Entity Type </mat-label>
                  <mat-select multiple formControlName="entityTypeIn">
                    <mat-option [value]="" *ngIf="productTypes.loading">
                      <i>Loading ...</i>
                    </mat-option>
                    <mat-option *ngFor="let prod of productTypes.response" [value]="prod.id">
                      {{ prod.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3" *ngIf="!this.approvedOnly">
              <div class="inputGroup">
                <mat-form-field class="w-100 mat-input-group" appearance="outline">
                  <mat-label class="matLabel">Status </mat-label>
                  <mat-select multiple formControlName="statusIn">
                    <mat-option [value]="" *ngIf="productStatus.loading"><i>Loading ...</i></mat-option>
                    <mat-option *ngFor="let prod of productStatus.response" [value]="prod.id">
                      {{ prod.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="inputGroup">
                <!-- <mat-form-field class="w-100 mat-input-group" appearance="outline">
                  <mat-label class="matLabel">Reg Date</mat-label>
                  <input matInput [matDatepicker]="picker" formControlName="publishedAt" />
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field> -->


              <div class="inputGroup daterange">
                <mat-form-field class="w-100 mat-input-group" appearance="outline">
                  <!-- <mat-label for="picker">Reg Date</mat-label> -->
                  <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate style="font-size: 15px;" (click)="picker.open()"
                      formControlName="dateFrom" readonly placeholder="Start date">
                    <input matEndDate style="font-size: 15px;" (click)="picker.open()" formControlName="dateTo" readonly
                      placeholder="End date">
                  </mat-date-range-input>
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
              </div>


                <!-- <mat-form-field class="w-100 mat-input-group">



                  <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate style="font-size: 15px; width: 40px;" (click)="picker.open()"
                      formControlName="dateFrom" readonly placeholder="Start date">
                    <input matEndDate style="font-size: 15px;" (click)="picker.open()" formControlName="dateTo" readonly
                      placeholder="End date">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                  </mat-form-field> -->


                  <!-- <div class="input-group datereg">
                    <input
                        class="form-control"
                        type="text"
                        matInput
                        ngxDaterangepickerMd
                        [locale]="{applyLabel: 'ok', format: 'DD/MM/YYYY'}"
                        [drops]="'down'"
                        [opens]="'right'"
                        [showCustomRangeLabel]="false"
                        [alwaysShowCalendars]="true"
                        [showDropdowns]="true"
                        [keepCalendarOpeningWithRange]="true"
                        [showCancel]="true"
                        autocomplete="off"
                        name="daterange"
                        [(ngModel)]="RegDates"
                        formControlName="dateFrom"
                        placeholder="Reg Dates"
                    />

                    <div class="input-group-append">
                      <div class="input-group-text">
                        <img src="./assets/images/calendar.svg" alt="CALENDER"/>
                      </div>
                    </div>
                  </div>
                </div> -->



                <!-- <mat-form-field class="w-100 mat-input-group" appearance="outline">
                  <mat-label class="matLabel">Reg Date</mat-label>
                  <mat-date-range-input formGroupName="dateRange">
                      <input matStartDate formControlName="start" placeholder="Start Date" />
                      <input matEndDate formControlName="end" placeholder="End Date" />
                  </mat-date-range-input>
                  <mat-datepicker-toggle matSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
                  <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
              </mat-form-field> -->
              </div>
            </div>
          </div>
        </div>
        <div class="text-center">
          <div class="btnbx mt-5">
            <button type="button" class="btnThemeOutline blue me-3" (click)="resetFilter()">
              Reset
            </button>
            <button class="btnTheme red" (click)="handleFilter()">
              Search
            </button>
          </div>
        </div>
      </form>
      <!-- <app-main-heading [title]="title" class="mt-4 d-block"></app-main-heading> -->

      <div class="top-categeryHead">
        <div class="categeryHead-text">
          <!-- <h1 [innerHTML]="title"></h1> -->
          <p style="margin-top: 17px;">
              <span class="text-red">Business </span>
            <span class="text-blue"> Validation</span>
          </p>
        </div>
        <div class="btnGrpp">
          <div class="serchblk">
            <div class="searchInputbx">
              <input type="text" [value]="searchProduct" class="inputBox2" id="weburl" placeholder=""
                (input)="searchProductOnChange($event)" />
              <div class="removeico" (click)="clearSearch()" *ngIf="searchProduct">
                <img src="assets/images/removeRoundgrey.svg" alt="Remove" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="tableSec mt-5">
        <table class="adminPanel-table text-center">
          <tr>
            <th></th>
            <th>Business Name</th>
            <th>Owner name</th>
            <th>Category</th>
            <th>Entity type</th>
            <th>STATUS</th>
            <th>Registration Date</th>
            <th>ACTIONS</th>
          </tr>
          <ng-container *ngIf="!loading && validationList.length; else showEmptyView">
            <tr *ngFor="let validate of validationList; index as i">
              <td class="serielNo">
                {{ i + 1 + this.pageLimit * (this.currentPage - 1) }}
              </td>
              <td>{{ validate?.business_name }}</td>
              <td>{{ validate?.owner_name }}</td>
              <td>{{ validate?.category }}</td>
              <td>{{ validate?.entity_type }}</td>
              <td>
                <select
                *ngIf="getCurrentStatus(statusWorkFlow,validate.status_id) && getCurrentStatus(statusWorkFlow,validate.status_id).length > 0; else status"
                class="bussValidation-tableSelect"
                name=""
                [(ngModel)]="validate.status_id"
                (change)="updateStatusOfBusiness($event, validate)">
                <option [value]="validate.status_id">{{validate.status}}</option>
                <option [value]="item.toStatusId" *ngFor="let item of getCurrentStatus(statusWorkFlow,validate.status_id)">{{item.toStatus}}</option>
            </select>
            <ng-template #status>
              {{validate.status}}
            </ng-template>
              </td>
              <td>
                {{ validate?.registration_date | date : "dd/MM/yyyy" }}
              </td>
              <td>
                <div class="actions">
                  <a [routerLink]="['/validation-details/', validate?.id ,0]" class="action" *ngIf="validate.status !== 'New Registration' && validate.status !== 'New Application'">
                    <img src="../../../assets/images/eye-line.svg" alt="" />
                  </a>

                  <!-- <a [routerLink]="['/validation-details/', validate?.id ,1]" class="action">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </a> -->
                  <a (click)="navigateToValidationDetails(validate?.id, validate.status_id)" class="action">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </a>
                </div>
              </td>
            </tr>
          </ng-container>
        </table>

        <app-pagination *ngIf="!this.loading" class="mt-4 d-block ps-lg-2" [currentPage]="currentPage"
          [totalItems]="totalRecords" [itemsPerPage]="pageLimit" (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"></app-pagination>
      </div>
    </div>
  </div>
</div>

<ng-template #showEmptyView>
  <tr *ngIf="!loading">
    <td colspan="9">
      <div class="nftd text-center p-4 d-block w-100">No Product found..</div>
    </td>
  </tr>
</ng-template>

<ng-template #loader>
  <div class="shimmertext">
    <span class="loader"></span>
  </div>
</ng-template>
